/*eslint no-undef: "off"*/

// Registers the resolver that turns a signal_watch notification into a route (module-scope import).
import '@/features/signal/notifications/registerSignalNotificationRoutes'

// Children of ViewAuthenticated for Signal
export const signalRoutes = [
    // Redirect for old /rate-search url
    {
        path: 'rate-search',
        redirect: { name: 'signal-index' },
    },
    {
        path: 'signal',
        component: () => import('@/features/signal/views/SignalRouterView.vue'),
        meta: { title: 'Signal' },
        // Strip ?signal-watch=true when the signal-watch feature flag is off.
        beforeEnter(to) {
            if (to.query['signal-watch'] === 'true') {
                const { featureFlags } = useAnalytics()
                if (!featureFlags.signalWatch) {
                    const query = { ...to.query }
                    delete query['signal-watch']
                    return { ...to, query }
                }
            }
        },
        children: [
            {
                path: '',
                name: 'signal-index',
                component: () => import('@/features/signal/views/index/SignalIndexView.vue'),
            },
            {
                path: 'new',
                name: 'signal-new',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },
            {
                path: 'starter-kits/:slug',
                name: 'signal-starter-kit',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },
            {
                path: ':id/:mode?',
                name: 'signal-show',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },
            {
                path: 'watch',
                name: 'signal-watch',
                component: () => import('@/features/signal/views/SignalWatchView.vue'),
            },
            {
                path: 'watch/new',
                name: 'signal-watch-new',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },
            // Preview of a report while building a Signal Watch (before it's saved).
            // Uses /watch/preview/:id/:mode? so preview URLs stay under
            // /signal/watch/... (and /watch/preview/:id/... won't be treated as
            // watch/:watchId).
            {
                path: 'watch/preview/:id/:mode?',
                name: 'signal-watch-preview',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },
            {
                path: 'watch/:watchId',
                name: 'signal-watch-show',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },

            // ── Legacy URL redirect ───────────────────────────────────────────────
            // Old shape: /signal/:mode/:signalId  →  new shape: /signal/:id/:mode
            // Matches any two-segment path not already claimed above where the first
            // segment looks like a mode slug (contains a hyphen or is 'search').
            {
                path: ':mode([a-z-]+)/:id',
                redirect: (to) => {
                    const modeMap = {
                        search: 'payer-data',
                        'market-benchmarks': 'market-overview',
                        'peer-benchmarks': 'peer-rates',
                        'peer-rollups': 'peer-service-lines',
                        'hospital-rate-search': 'hospital-data',
                    }
                    const mode = modeMap[to.params.mode] ?? to.params.mode
                    return { name: 'signal-show', params: { id: to.params.id, mode } }
                },
            },
        ],
    },
]
